import { Smartphone } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { Puce, Riche, Tableau } from './constantes';
import { Captures, Chemin, Ecran } from './CoursElements';

const Partie = ({ p, k, teinte }) => (
  <div className="space-y-4">
    {p.texte && <p className="text-sm leading-relaxed text-slate-700"><Riche texte={p.texte} /></p>}
    {p.schemas?.map((s, j) => <Ecran key={s.titre} s={s} teinte={teinte} testId={`guide-cours-schema-${k}-${j}`} />)}
    {p.chemins && (
      <div className="grid gap-2 lg:grid-cols-2">
        {p.chemins.map((c, j) => <Chemin key={c.titre} c={c} teinte={teinte} testId={`guide-cours-chemin-${k}-${j}`} />)}
      </div>
    )}
    {p.liste && <ul className="space-y-1.5">{p.liste.map((x) => <Puce key={x}>{x}</Puce>)}</ul>}
    {p.captures && <Captures items={p.captures} />}
    {p.colonnes && <Tableau o={p} teinte={teinte} />}
    {p.exemple && (
      <p className="rounded-xl border-l-4 border-[#E9A23B] bg-[#FFF8E6] p-3.5 text-sm italic text-[#7A4B00]"><b className="not-italic">Exemple : </b>{p.exemple}</p>
    )}
    {p.note && <p className="text-xs italic text-slate-500">{p.note}</p>}
  </div>
);

export const CoursReseaux = ({ o, teinte }) => (
  <div className={`rounded-2xl border-2 p-4 sm:p-6 ${teinte.bord}`} data-testid="guide-cours-reseaux">
    <p className="flex gap-3 text-sm leading-relaxed text-slate-700">
      <Smartphone className={`h-5 w-5 shrink-0 ${teinte.texte}`} />{o.intro}
    </p>
    <Accordion type="multiple" defaultValue={['partie-0']} className="mt-4">
      {o.parties.map((p, k) => (
        <AccordionItem key={p.titre} value={`partie-${k}`} data-testid={`guide-cours-partie-${k}`}>
          <AccordionTrigger className="text-left text-sm font-bold text-[#0F172A] hover:no-underline" data-testid={`guide-cours-partie-btn-${k}`}>
            {p.titre}
          </AccordionTrigger>
          <AccordionContent><Partie p={p} k={k} teinte={teinte} /></AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
);
